import { registerComponent, asyncRequest, debounce, loading } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "cart-items",
  class CartItems extends WYATTElement {
    SECTIONS_TO_RENDER = [
      {
        name: "cart-count",
        liveRegion: "cart-count",
      },
      {
        name: "cart",
        liveRegion: "cart-items",
      },
      {
        name: "cart",
        liveRegion: "cart-totals",
      },
      {
        name: "cart",
        liveRegion: "cart-checkout",
      },
      {
        name: "cart",
        liveRegion: "cart-upsells",
      },
    ];

    constructor() {
      super();

      this.removeButtons = this.querySelectorAll("[data-remove-item-button]");
      this.form = this.querySelector("form");
      this.currentItemCount = Array.from(
        this.querySelectorAll('[name="updates[]"]'),
      ).reduce(
        (total, quantityInput) => total + parseInt(quantityInput.value, 10),
        0,
      );

      this.removeButtons.forEach((button) => {
        button.addEventListener("click", this.remove.bind(this));
      });

      this.confirmRegistryAttributes();

      const debouncedChangeHandler = debounce((event) => {
        this.handleChange(event);
      }, 300);

      this.form?.addEventListener("change", debouncedChangeHandler);
    }

    remove(event) {
      const line = event.currentTarget.dataset.removeItemButton;

      event.preventDefault();

      this.updateQuantity(line, 0);
    }

    handleChange(event) {
      this.updateQuantity(
        event.target.dataset.lineItemIndex,
        event.target.value,
      );
    }

    getSectionNames() {
      return [
        ...new Set(this.SECTIONS_TO_RENDER.map((section) => section.name)),
      ];
    }

    async updateQuantity(line, quantity) {
      const body = {
        line,
        quantity,
        sections: this.getSectionNames(),
        sections_url: WYATT.routes.cart_url,
      };
      const options = {
        ...WYATT.config.fetch.post,
        ...{ body: JSON.stringify(body) },
      };

      loading.add(this);

      const response = await asyncRequest(
        WYATT.routes.cart_change_url,
        options,
        {
          messageOptions: {
            minDelay: 6000,
            appendPoint:
              '[data-mini-cart][active="true"] [data-dialog-messages], #page-messages',
          },
        },
      );

      if (response) {
        this.handleSuccessfulUpdate(response);
      }

      loading.remove(this);
    }

    handleSuccessfulUpdate(state) {
      const parsedState = JSON.parse(state);

      this.publish(
        WYATT.PubSub.events.updateDOM,
        this.SECTIONS_TO_RENDER.map(({ liveRegion, name }) => ({
          liveRegion,
          html: parsedState.sections[name],
        })),
      );
    }

    confirmRegistryAttributes() {
      const shouldRemove = this.config.registryRemove
        ? JSON.parse(this.config.registryRemove)
        : false;
      const attributes = {};

      if (!shouldRemove) {
        return;
      }

      this.config.registryAttributes.split(",").forEach((attribute) => {
        if (attribute) {
          attributes[attribute] = null;
        }
      });

      asyncRequest(`${WYATT.routes.cart_update_url}.js`, {
        ...WYATT.config.fetch.post,
        ...{ body: JSON.stringify({ attributes }) },
      });
    }
  },
);
